import { render, staticRenderFns } from "./ScreenCaptureOrg.vue?vue&type=template&id=4fc81ba6"
import script from "./ScreenCaptureOrg.vue?vue&type=script&lang=js"
export * from "./ScreenCaptureOrg.vue?vue&type=script&lang=js"
import style0 from "./ScreenCaptureOrg.vue?vue&type=style&index=0&id=4fc81ba6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports